export const PRESET_PREFIXES = [
  'areas_comunes_',
  'plano_modelo_',
  'fachada_',
  'interior_',
  'amenidades_',
  'vista_aerea_',
  'emplazamiento_masterplan_',
] as const;

export type PresetPrefix = (typeof PRESET_PREFIXES)[number];

export const getPresetPrefix = (name: string): PresetPrefix | null =>
  PRESET_PREFIXES.find((p) => name.startsWith(p)) ?? null;

export const applyPresetPrefix = (name: string, newPrefix: PresetPrefix): string => {
  const existing = getPresetPrefix(name);
  const base = existing ? name.slice(existing.length) : name;
  return `${newPrefix}${base}`;
};

export const countByPresetPrefix = (names: string[]): Record<PresetPrefix, number> => {
  const counts = Object.fromEntries(PRESET_PREFIXES.map((p) => [p, 0])) as Record<PresetPrefix, number>;
  names.forEach((name) => {
    const prefix = getPresetPrefix(name);
    if (prefix) counts[prefix] += 1;
  });
  return counts;
};

export const formatPrefixLabel = (prefix: PresetPrefix): string => prefix.replace(/_$/, '');
